import { render, staticRenderFns } from "./PhoneSignin.vue?vue&type=template&id=465b9a4a&"
import script from "./PhoneSignin.vue?vue&type=script&lang=js&"
export * from "./PhoneSignin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports